import { createSelector } from 'reselect';
import isEmpty from 'lodash/isEmpty';
import { getFormValues, isInvalid } from 'redux-form';
import { initialState } from './reducer';
import { ICEPACK_FILLER_FORM_NAME, ICEPACK_FILLER_TABLE_ROWS_NAMES } from './constants';

export const selectIcepackFillerModalDomain = state => state.icepackFillerModalReducer || initialState;

export const selectRouterDomain = state => state.router || {};

export const getIsModalShownSelector = () =>
	createSelector(selectRouterDomain, ({ location: { query } }) => {
		return Boolean(!isEmpty(query) && query?.modal === 'icepack_filler');
	});

export const getIsAuditTabShownSelector = () =>
	createSelector(selectRouterDomain, ({ location: { query } }) => {
		return Boolean(!isEmpty(query) && query?.modal === 'icepack_filler' && query?.id && query?.tab === 'audit');
	});

export const getActiveIcepackFillerIdSelector = () =>
	createSelector(selectRouterDomain, ({ location: { query } }) => {
		return query?.modal === 'icepack_filler' ? query?.id : null;
	});

export const getIsIcepackFillerInfoLoadingSelector = () =>
	createSelector(selectIcepackFillerModalDomain, ({ isIcepackFillerInfoLoading }) => isIcepackFillerInfoLoading);

export const getIcepackFillerInfoSelector = () =>
	createSelector(selectIcepackFillerModalDomain, ({ icepackFillerInfo }) => {
		return Object.entries(ICEPACK_FILLER_TABLE_ROWS_NAMES).reduce((result, [key, value]) => {
			if (key === 'author') {
				result.push({
					id: key,
					title: value,
					value: {
						name: `${icepackFillerInfo?.user?.last_name || ''} ${
							icepackFillerInfo?.user?.first_name || ''
						}`,
						role: icepackFillerInfo?.user?.role?.name || '',
					},
				});

				return result;
			}

			result.push({
				id: key,
				title: value,
				value: icepackFillerInfo[key] ?? '-',
			});

			return result;
		}, []);
	});

export const getIcepackFillerNameSelector = () =>
	createSelector(selectIcepackFillerModalDomain, ({ icepackFillerInfo }) => icepackFillerInfo?.name ?? '');

export const getIsIcepackFillerAddFormOpenSelector = () =>
	createSelector(selectRouterDomain, ({ location: { query } }) => {
		return Boolean(!isEmpty(query) && query?.modal === 'icepack_filler' && query?.mode === 'add');
	});

export const getIsIcepackFillerCreatingSelector = () =>
	createSelector(selectIcepackFillerModalDomain, ({ isIcepackFillerCreating }) => isIcepackFillerCreating);

export const getIsIcepackFillerEditFormOpenSelector = () =>
	createSelector(selectRouterDomain, ({ location: { query } }) => {
		return Boolean(!isEmpty(query) && query?.modal === 'icepack_filler' && query?.mode === 'edit');
	});

export const getIsIcepackFillerUpdatingSelector = () =>
	createSelector(selectIcepackFillerModalDomain, ({ isIcepackFillerUpdating }) => isIcepackFillerUpdating);

export const getIsIcepackFillerDeletingSelector = () =>
	createSelector(selectIcepackFillerModalDomain, ({ isIcepackFillerDeleting }) => isIcepackFillerDeleting);

export const getFormInitialValuesSelector = () =>
	createSelector(selectIcepackFillerModalDomain, ({ icepackFillerInfo }) => icepackFillerInfo);

export const getDataForSaveSelector = () =>
	createSelector(getFormValues(ICEPACK_FILLER_FORM_NAME), formValues => {
		return {
			name: formValues?.name,
		};
	});

export const getFormIsInvalidSelector = () =>
	createSelector(isInvalid(ICEPACK_FILLER_FORM_NAME), isInvalid => isInvalid);
